import ListDrivers from "../../../../components/@users/drivers/ListDrivers";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DriversPage() {

    return (
        <ListDrivers 
            routeType={routeTypes.admin}
        />
    )
}       